import { AuxiliumComponent } from "../auxilium-component";

export class Loading extends AuxiliumComponent {
	constructor() {
		super();

		this.type = this.getAttribute("type");
	}

	parsedCallback() {
		this.innerHTML = (() => {
			switch (this.type) {
				default: return '<div class="pv-loading-container"><div class="pv-loading-icon"></div></div>';
			}
		})();
	}
}